<template>
    <div>
        <p class="timeline-talks">{{ message }}</p>
    </div>
</template>

<script>
export default {
    /*
    |--------------------------------------------------------------------------
    | Component > computed
    |--------------------------------------------------------------------------
    */

    computed: {
        message() {
            return 'Simulation process has been performed by Idenfo System'
        },
    },
}
</script>
